import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const AudienceDailyVisitors = ({ data }) => {
    const chartData = (data || []).map((item) => ({ date: item.date, visitors: item.visitors }));

    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-emerald-50/30 to-white p-5">
            <h2 className="text-sm font-semibold text-slate-900">Daily Visitors</h2>
            <p className="mb-3 text-xs text-slate-500">Visitor growth over time</p>

            <div className="h-[240px]">
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={chartData} margin={{ left: -16, right: 8, top: 4 }}>
                        <defs>
                            <linearGradient id="visitorFill" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#10B981" stopOpacity={0.35} />
                                <stop offset="100%" stopColor="#10B981" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#ECFDF5" />
                        <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                        <YAxis allowDecimals={false} tick={{ fontSize: 11 }} width={36} />
                        <Tooltip contentStyle={{ borderRadius: 10, border: "1px solid #E2E8F0", fontSize: 12 }} />
                        <Area type="monotone" dataKey="visitors" stroke="#10B981" strokeWidth={2.5} fill="url(#visitorFill)" activeDot={{ r: 5 }} />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default AudienceDailyVisitors;